export const TextStyle = {
  fontFamily: 'Roboto',
  fontStyle: 'normal',
  fontSize: '14px',
  lineHeight: '20px',
  letterSpacing: '0.15px',
  color: 'rgba(0, 0, 0, 0.87)',
}
